import ContactPage from '../elements/ContactPage';

function Questionnaire() {
  return <ContactPage initialTab="questionnaire" />;
}

export default Questionnaire;
